import { render, staticRenderFns } from "./NewsPostOverview.vue?vue&type=template&id=25df0af8&scoped=true&"
import script from "./NewsPostOverview.vue?vue&type=script&lang=js&"
export * from "./NewsPostOverview.vue?vue&type=script&lang=js&"
import style0 from "./NewsPostOverview.vue?vue&type=style&index=0&id=25df0af8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df0af8",
  null
  
)

export default component.exports